import request from "./request";
/**
 * 获取帖子互动数据信息
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getInteractionByPageId(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
    order: "asc",
  };
  return await request.get("/spin/dataSend/getInteractionByPageId", {
    params: { ...defaultParams, ...params },
  });
}
